import { Pipe, PipeTransform } from '@angular/core';
import { formatStoredPhone } from '../phone/phone-format';

@Pipe({
    name: 'phone'
})
export class PhonePipe implements PipeTransform {
    transform(value: string): string {
        return typeof value === 'string' ? formatStoredPhone(value) : value;
    }
}
